/**
 * RecoverPasswordRequest
 * @author Simpli CLI generator
 */
import {Model} from 'simpli-web-sdk'
import {
  ResponseHidden,
  ValidationMaxLength,
  ValidationPasswordLength,
} from 'simpli-web-sdk'

export default class ChangeTemporaryPasswordRequest extends Model {
  readonly $name: string = 'ChangeTemporaryPasswordRequest'

  @ResponseHidden()
  @ValidationPasswordLength(6, 100)
  newPassword: string | null = null

  @ResponseHidden()
  @ValidationPasswordLength(6, 100)
  confirmPassword: string | null = null

  @ResponseHidden()
  @ValidationPasswordLength(6, 100)
  oldPassword: string | null = null

  @ValidationMaxLength(255)
  user: string | null = null
}
